module.exports = __webpack_public_path__ + "static/img/boron-1.f729982.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/boron-1.jpg
// module id = cBbj
// module chunks = 1